import { render, staticRenderFns } from "./CertificateList.vue?vue&type=template&id=241d94ca&scoped=true"
import script from "./CertificateList.vue?vue&type=script&lang=js"
export * from "./CertificateList.vue?vue&type=script&lang=js"
import style0 from "./CertificateList.vue?vue&type=style&index=0&id=241d94ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d94ca",
  null
  
)

export default component.exports